import { GetPropertyById200Response } from '@/api/generated/fetch-client';
import { Image } from '@/types/typings';
import { LatLngExpression } from 'leaflet';

import { PropertyType } from '@/features/accommodation/types/ws/websocket-message';

export class AccommodationDetailModel {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly address: string,
    readonly stars: number,
    readonly services: string[],
    readonly images: Image[],
    readonly description: string,
    readonly location: string,
    readonly point: LatLngExpression | null,
    readonly policy: {
      checkIn: string;
      checkOut: string;
    },
    readonly type: PropertyType,
    readonly rating: number,
    readonly reviewCount: number,
  ) {}

  public static fromDto(
    dto: GetPropertyById200Response,
    propertyType: PropertyType,
  ): AccommodationDetailModel {
    return new AccommodationDetailModel(
      dto.id,
      dto.name,
      dto.address,
      dto.stars ?? 0,
      dto.services,
      dto.images,
      dto.description,
      dto.address,
      dto.latitude === null || dto.longitude === null
        ? null
        : [dto.latitude, dto.longitude],
      {
        checkIn: dto.policy.checkIn,
        checkOut: dto.policy.checkOut,
      },
      propertyType,
      dto.rating,
      dto.reviewCount,
    );
  }
}
